import { Link } from "react-router-dom";
import { COMPANY } from "@/data/site";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="global-footer" className="bg-primary text-primary-foreground">
      <div className="container-x py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="font-serif text-4xl md:text-5xl leading-tight">MIM Engineering</div>
            <p className="mt-6 text-white/70 max-w-md leading-relaxed">
              A Bayswater-based precision engineering workshop delivering machining, fabrication, fitting and
              maintenance solutions across Western Australia.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow text-white/50">Sitemap</p>
            <ul className="mt-4 space-y-2 text-white/80">
              <li><Link className="link-underline" to="/services">Services</Link></li>
              <li><Link className="link-underline" to="/machine-capacity">Machine Capacity</Link></li>
              <li><Link className="link-underline" to="/industries">Industries</Link></li>
              <li><Link className="link-underline" to="/gallery">Gallery</Link></li>
              <li><Link className="link-underline" to="/about">About</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4" data-testid="footer-contact-info">
            <p className="eyebrow text-white/50">Contact</p>
            <ul className="mt-4 space-y-3 text-white/85">
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-accent" /> {COMPANY.address}</li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-accent" /> <a className="link-underline" href={`tel:${COMPANY.phone.replace(/\s/g,'')}`}>{COMPANY.phone}</a></li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-accent" /> <a className="link-underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
              <li className="text-white/60 pt-2">{COMPANY.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-white/60 text-sm">
          <span>© {new Date().getFullYear()} MIM Engineering. All rights reserved.</span>
          <span className="text-white/40">Quality Assured · Safety First · ABN-Verified Workshop</span>
        </div>
      </div>
    </footer>
  );
}
